import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { sendDispatchEvent } from '@/utils/utils'
import { lkidListFooterByArea } from '@/utils/constants'
import { config } from 'config/config'

import {
  Container,
  Wrapper,
  CertifiedPurchaseTag,
  Text,
  Highlight,
  List,
  ListItem,
  StampWrapper,
  Button,
  PdfNotFound,
  AlertIcon,
  StampText,
  Footer,
  FooterText,
  FooterLink,
  FooterWarningText,
} from './style'

const CertifiedPurchaseSection = ({
  id,
  className,
  title,
  ad,
  trackingHandler,
}) => {
  const {
    IsElegibleVehicleInspection: shouldRender = false,
    VehicleInspection: { PdfPath = '' } = {},
  } = ad

  const { SERVICES } = lkidListFooterByArea

  const buttonText = 'Visualizar laudo'
  const buttonDataQA = 'btn_certified_purchase'

  useEffect(() => {
    if (shouldRender && PdfPath === '') {
      sendDispatchEvent('visualizarLaudoVistoriadoErro')
    }
  }, [PdfPath, shouldRender])

  return shouldRender ? (
    <Container className={className} id={id} title={title}>
      <Wrapper>
        <CertifiedPurchaseTag shouldRender theme="white" size="big" />
        <Text>
          Confiança e tranquilidade na compra do seu seminovo aqui na Webmotors
        </Text>
        <Highlight>Diversos itens inspecionados</Highlight>
        <List>
          <ListItem>Estrutura</ListItem>
          <ListItem>Indício de sinistro</ListItem>
          <ListItem>Funilaria</ListItem>
          <ListItem>Interior</ListItem>
          <ListItem>Débitos</ListItem>
          <ListItem>Restrições</ListItem>
        </List>

        <StampWrapper>
          <div>
            <StampText>Você mais seguro na hora de fechar o negócio!</StampText>
            {PdfPath && (
              <Button
                dataQA={buttonDataQA}
                href={PdfPath}
                onClick={trackingHandler}
                target="_blank"
                rel="noopener"
              >
                {buttonText}
              </Button>
            )}
            {!PdfPath && (
              <Fragment>
                <Button
                  dataQA={buttonDataQA}
                  className="Button--disabled"
                  disabled
                >
                  {buttonText}
                </Button>
                <PdfNotFound>
                  <AlertIcon />
                  <p>
                    Infelizmente não encontramos o laudo dessa vistoria, você
                    pode tentar de novo mais tarde ;)
                  </p>
                </PdfNotFound>
              </Fragment>
            )}
          </div>
        </StampWrapper>

        <Footer>
          <FooterText>Ainda com dúvidas sobre o Vistoriado?</FooterText>
          <FooterLink
            data-qa="certified_purchase_know_more"
            href={`${config.urlVistoriado}?lkid=${SERVICES.VISTORIADO}`}
            target="_blank"
            rel="noopener"
          >
            Saiba mais
          </FooterLink>
        </Footer>
        <FooterWarningText>
          A Webmotors não possui qualquer ingerência ou responsabilidade em
          relação ao laudo cautelar, atuando meramente como um classificado de
          anúncios de veículos com atribuição do selo VISTORIADO, sendo as
          vistoriadoras as únicas responsáveis pelo laudo cautelar emitido,
          assim como os itens vistoriados.
        </FooterWarningText>
      </Wrapper>
    </Container>
  ) : null
}

CertifiedPurchaseSection.defaultProps = {
  id: '',
  className: '',
  title: '',
  ad: {},
  trackingHandler: () => null,
}

CertifiedPurchaseSection.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  ad: PropTypes.oneOfType([PropTypes.object]),
  trackingHandler: PropTypes.func,
}

export default CertifiedPurchaseSection
